export default class OnHandItemDisplayModel {
    constructor(itemTab, itemContent, itemConfirm) {
        this.itemTab = itemTab;
        this.itemContent = itemContent;
        this.itemConfirm = itemConfirm; // optional
    }
}
